<template>
  <div id="quotation">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Quản lý lệnh chế tạo', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="bmanufacture" class="soft-control">
        <control-panel
          :disabled="{
            edit: true,
            print: true
          }"
          :countChecked="countChecked"
          @doAddNew="handleCreate"
          @search="handleSearch"
          @copy="handleCopy"
          :help="handleHelp"
          @doDelete="handleDelete"
          :onlySearch="true"
        ></control-panel>
        <div class="row p-1">
          <div class="col-md-12">
            <b-tabs>
              <b-tab @click="doFilter('DANGSX')" title="ĐANG SẢN XUẤT" active></b-tab>
              <b-tab @click="doFilter('DADUHANG')" title="ĐÃ ĐỦ HÀNG"></b-tab>
              <b-tab @click="doFilter('ALL')" title="Tất cả"></b-tab>
            </b-tabs>
            <soft-table
              @rowSelected="tbSetRowSelected"
              @rowClicked="tbRowClicked"
              class="table align-items-center table-flush"
              tbody-classes="list"
              :pending="false"
              :showAll="true"
              :dataTable="tableData"
              :fields="fields"
              :minHeight="$hControl"
              ref="soft-table"
            >
              <template v-slot:cell(code)="row">
                <b-button @click="row.toggleDetails" variant="link" style="font-size:17px; padding:0">
                  {{ row.value }}
                </b-button>
              </template>
              <template v-slot:row-details="row">
                <div class="py-2" style="background:#fff">
                  <b-row align-h="center" class="mx-0">
                    <template v-if="row.item.status">
                      <b-button @click="printOrder(row.item)" variant="primary" class="mt-2" size="lg">
                        <i class="fa fa-print" aria-hidden="true"></i>
                        In Lệnh chế tạo
                      </b-button>
                      <!-- <b-button
                        v-if="row.item.status < 2"
                        @click="printOrder(row.item)"
                        variant="primary"
                        class="mt-2"
                        size="lg"
                      >
                        <i class="fa fa-print" aria-hidden="true"></i>
                        In Lệnh chế tạo
                      </b-button> -->
                      <b-button @click="createTem(row.item)" variant="primary" class="mt-2" size="lg">
                        <i class="fa fa-print" aria-hidden="true"></i>
                        In Tem
                      </b-button>
                      <b-button @click="updateStatus(row.item)" variant="success" class="mt-2" size="lg">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Cập nhật trạng thái
                      </b-button>
                      <b-button
                        v-if="row.item.quantityProduce > 0 && row.item.totalWarehouse < row.item.quantityProduce"
                        @click="InputWarehouse(row.item)"
                        variant="primary"
                        class="mt-2"
                        size="lg"
                      >
                        <i class="fas fa-warehouse    "></i>
                        Tạo phiếu nhập kho
                      </b-button>
                    </template>
                    <template v-else>
                      <b-button @click="verifyOrder(row.item)" variant="success" class="mt-2" size="lg">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Duyệt lệnh chế tạo
                      </b-button>
                      <b-button @click="handleUpdate(row.item, row.index)" variant="info" class="mt-2" size="lg">
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Cập nhật lệnh chế tạo
                      </b-button>
                    </template>
                  </b-row>
                  <b-row class="mx-0 mt-2">
                    <b-col md="4">
                      <base-input v-model="row.item.userCreate.name" readonly label="Tạo bởi"> </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input
                        :value="row.item.userVerify ? row.item.userVerify.name : 'Chưa có người duyệt'"
                        readonly
                        label="Người duyệt"
                      >
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <div class="form-group has-label">
                        <label class="form-control-label">
                          Trạng thái :
                        </label>
                        <br />
                        <h3>
                          <b-badge pill v-if="row.item.status" variant="success">
                            Đã duyệt
                          </b-badge>
                          <b-badge pill v-else variant="danger">
                            Chưa được duyệt
                          </b-badge>
                        </h3>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mx-0 mt-2">
                    <b-col md="3">
                      <base-input readonly label="Hệ màu" v-model="row.item.color.label"></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input readonly label="Màu sắc" v-model="row.item.colorText"></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input readonly label="Mã màu 1" v-model="row.item.colorCode1"></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input readonly label="Mã màu 1" v-model="row.item.colorCode2"></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input readonly :mask="'number'" label="Định mức" v-model="row.item.quota"></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input readonly label="Co giãn" v-model="row.item.elastic"></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input readonly label="Quy cách (mm)" v-model="row.item.productSpecify.name"></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input readonly label="Chiều dài (cm)" v-model="row.item.length"></base-input>
                    </b-col>
                  </b-row>
                  <div class="p-3">
                    <base-table :data="row.item.manufactureFeatures">
                      <template slot="columns">
                        <th>STT</th>
                        <th>Công dụng</th>
                        <th>Nguyên liệu</th>
                        <th>Quy cách</th>
                        <th>Màu sắc</th>
                        <th>Mã màu 1</th>
                        <th>Mã màu 2</th>
                        <th>Số lượng</th>
                        <th>% Sợi</th>
                        <th>Trọng lượng kg</th>
                        <th>% Hao hụt</th>
                        <th>Tổng trọng lượng kg</th>
                      </template>

                      <template slot-scope="{ row, index }">
                        <tr :key="index">
                          <td class="bg-info text-light col-fix ">
                            {{ index + 1 }}
                          </td>
                          <td>{{ row.deportment }}</td>
                          <td class="text-center">{{ row.material }}</td>
                          <td class="text-center">{{ row.spec }}</td>
                          <td class="text-center">{{ row.color.label }}</td>
                          <td class="text-center">{{ row.colorCode1 }}</td>
                          <td class="text-center">{{ row.colorCode2 }}</td>
                          <td class="text-center">
                            {{ row.quantity }}
                          </td>
                          <td class="text-right">{{ $formatNumber(row.percentYarn) }} %</td>
                          <td class="text-right">{{ $formatNumber(row.weight) }} kg</td>
                          <td class="text-right">{{ $formatNumber(row.percentLoss) }} %</td>
                          <td class="text-right">{{ $formatNumber(row.total_weight) }} kg</td>
                        </tr>
                      </template>
                      <!-- <template slot="tfoot">
                        <tr>
                          <th colspan="7">Tổng cộng</th>
                          <th colspan="2" style="text-align:right">
                            {{ $formatNumber(summary.percentYarn) }} %
                          </th>
                          <th style="text-align:right">
                            {{ $formatNumber(summary.weight) }} Kg
                          </th>
                          <th></th>
                          <th style="text-align:right">
                            {{ $formatNumber(summary.total_weight) }} Kg
                          </th>
                        </tr>
                      </template> -->
                    </base-table>

                    <table class="">
                      <tr v-for="(item, index) in row.item.manufactureParameters" :key="index">
                        <td>
                          <div v-html="item.col1"></div>
                        </td>
                        <!-- <td>{{ index + 1 }} /</td> -->
                        <!-- <td>{{ item.col1 }}</td>
                        <td>{{ item.col2 }}</td>
                        <td>{{ item.col3 }}</td>
                        <td>{{ item.col4 }}</td> -->
                      </tr>
                    </table>
                  </div>
                </div>
              </template>
              <template v-slot:cell(poCode)="{ value }">
                {{ value }}
              </template>
              <template v-slot:cell(product)="{ item }">
                Mã: <b>{{ item.product.code }}</b> <br />
                Tên: <span>{{ item.product.name }}</span> <br />
                Quy cách: <span style="font-size: 65%">{{ item.productSpecify.id }} -</span>
                <span> {{ item.productSpecify.name }}mm</span>
                <span v-if="item.productSpecify.color && item.productSpecify.color.id">
                  -{{ item.productSpecify.color.label }}
                </span>
                <br />
              </template>
              <template v-slot:cell(color)="{ item }">
                <!-- Màu sắc: <b v-if="item.color">{{ item.color.label }}</b> <br /> -->
                Màu sắc: <b>{{ item.colorText }}</b> <br />
                Mã màu 1: <span>{{ item.colorCode1 }}</span> <br />
                Mã màu 2: <span>{{ item.colorCode2 }}</span> <br />
              </template>
              <template v-slot:cell(customer)="{ value }">
                MS: <b>{{ value.code }}</b> <br />
                Tên: <span>{{ value.name }}</span> <br />
                MST: <span>{{ value.taxCode }}</span> <br />
              </template>
              <template v-slot:cell(manufactureParameters)="{ value }">
                <div class="note-lct-index">
                  <div v-for="(item, index) in value" :key="index">
                    <div v-html="item.col1"></div>
                  </div>
                </div>
              </template>

              <template v-slot:cell(quantityOrder)="{ item }">
                Số lượng đặt: <b>{{ item.quantityOrder }}</b> {{ item.unit }}<br />
                Số lượng đã sản xuất: <b>{{ item.quantityProduce }}</b> {{ $ucWord(item.unit) }} <br />
                Số lượng tồn:
                <span v-if="item.product.info"> {{ item.product.info.quantity }} {{ $ucWord(item.unit) }} </span>
                <b-badge v-else>Không có hàng tồn</b-badge>
                <br />
                Số lượng nhập kho: <b>{{ calcQuantityWarehouse(item) }}</b>
                {{ $ucWord(item.unit) }}
                <br />
                Số lượng dệt: <span>{{ item.quantityInventory }}</span> {{ $ucWord(item.unit) }}
                <br />
              </template>
              <template v-slot:cell(dateReceipt)="{ value }">
                {{ $date(value) }}
              </template>
              <template v-slot:cell(dateDelivery)="{ value }">
                {{ $date(value) }}
              </template>
              <template v-slot:cell(amount)="{ value }" th-class="text-right col-fix">
                {{ $formatNumber(value) }}
              </template>
              <template v-slot:cell(note)="{ value }">
                <div v-html="value"></div>
              </template>
              <template v-slot:cell(userCreate)="{ value }">
                <span v-if="value.id" class="badge badge-primary">{{ value.username }}</span>
              </template>
              <template v-slot:cell(userVerify)="{ value }">
                <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
                <span v-else class="badge badge-danger">
                  Chưa được duyệt
                </span>
              </template>
              <template v-slot:cell(userManage)="{ value }">
                <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
                <span v-else class="badge badge-danger">
                  Chưa có người hỗ trợ
                </span>
              </template>
              <template>
                <pagination
                  class="mr-2 my-1"
                  slot="footer"
                  :value="listQuery.page"
                  :total="listQuery.total"
                  :perPage="listQuery.limit"
                  @change="pagChange"
                />
              </template>
            </soft-table>
          </div>
        </div>
      </block>
      <preview ref="preview"></preview>
      <status ref="status"></status>
    </div>
  </div>
</template>
<script>
import { manufactureService } from '@/_services';
import Preview from './__Preview';
import Status from './__Status';
export default {
  name: 'manufacture-manage',
  components: {
    Preview,
    Status
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        status: 1
      },
      lastIndexSelected: 0,
      info: {},
      mode: 'DANGSX',
      tableData: [],
      tableDataSelecteds: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'col-fix checkbox'
        },
        {
          key: 'code',
          label: 'Mã LCT',
          sortable: true,
          stickyColumn: true,
          class: 'col-fix'
        },
        {
          key: 'product',
          label: 'Thông tin SP',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'color',
          label: 'Thông tin màu',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'customer',
          label: 'Thông tin đặt',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'quantityOrder',
          label: 'Số lượng',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'dateDelivery',
          label: 'Ngày giao',
          sortable: true,
          class: 'text-center'
        },
        {
          tdClass: 'text-center',
          key: 'userCreate',
          label: 'Người tạo',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userVerify',
          label: 'Người duyệt',
          sortable: true
        },
        {
          key: 'manufactureParameters',
          label: 'Ghi chú',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'dateCreated',
          label: 'Ngày tạo',
          sortable: true
        }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let strRow = localStorage.getItem('manufacture_edit');
      if (strRow) {
        this.listQuery.sortmode = 2;
      }
      this.$refs.bmanufacture.block();
      manufactureService
        .findAll(this.listQuery)
        .then(res => {
          let tableData = res.data.data;
          this.allData = tableData;
          this.tableData = [...tableData];
          //this.doFilter(this.mode);
          this.listQuery.total = res.data.total;

          let strRow = localStorage.getItem('manufacture_edit');
          if (strRow) {
            let index = JSON.parse(strRow);
            if (index) {
              this.$refs['soft-table'].selectRow(0);
              localStorage.removeItem('manufacture_edit');
            } else {
              this.$refs['soft-table'].selectRow(this.lastIndexSelected);
            }
          } else {
            this.$refs['soft-table'].selectRow(this.lastIndexSelected);
          }
        })
        .finally(() => {
          this.$refs.bmanufacture.unBlock();
        });
    },
    doFilter(mode = 'DANGSX') {
      this.listQuery.page = 1;
      this.mode = mode;
      if (mode == 'ALL') {
        this.listQuery.status = -1;
      } else if (mode == 'DANGSX') {
        this.listQuery.status = 1;
      } else if (mode == 'DADUHANG') {
        this.listQuery.status = 2;
      }
      this.fetchData();
    },
    doFilter2(mode = 'DANGSX') {
      this.mode = mode;
      if (mode == 'ALL') {
        this.tableData = [...this.allData];
      } else {
        let tableData = [];
        if (mode == 'DANGSX') {
          this.allData.forEach(element => {
            if (element.status <= 1) {
              tableData.push(element);
            }
          });
        } else if (mode == 'DADUHANG') {
          this.allData.forEach(element => {
            if (element.status > 1) {
              tableData.push(element);
            }
          });
        }
        this.tableData = tableData;
      }
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log('context menu', a);
    },
    handleUpdate(row, index) {
      localStorage.setItem('manufacture_edit', index);
      this.$router.push({
        name: 'add-manufacture',
        query: {
          edit_id: row.id
        }
      });
    },
    updateStatus(item) {
      this.$refs.status.visible = true;
      this.$refs.status.setData(item);
    },
    handleCreate() {
      this.$router.push({
        name: 'add-manufacture'
      });
    },
    handleCopy() {
      this.$router.push({
        name: 'add-manufacture',
        query: {
          copy_id: this.info.id
        }
      });
    },
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
      let listRemove = [];
      this.tableDataSelecteds.forEach(element => {
        listRemove.push(element.id);
      });
      this.$refs.bmanufacture.block();
      manufactureService
        .removeList(listRemove)
        .then(res => {
          this.lastIndexSelected = 0;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.fetchData();
          this.$refs.bmanufacture.unBlock();
        });
    },
    tbSetRowSelected(items) {
      this.tableDataSelecteds = items;
      this.countChecked = items.length;
    },
    createTem(item) {
      this.$router.push({
        name: 'tem-add',
        query: {
          manufacture: item.id
        }
      });
    },
    InputWarehouse(item) {
      this.$router.push({
        name: 'receipt-add-in',
        query: {
          manufacture: item.id
        }
      });
    },
    verifyOrder(item) {
      this.$refs.bmanufacture.block();
      manufactureService
        .verify(item.id)
        .then(res => {
          item.status = true;
          item.userVerify = res.data.userVerify;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.$refs.bmanufacture.unBlock();
        });
    },
    calcQuantityWarehouse(item) {
      let oldReceiptBillDetails = item.receiptBillDetails;
      let quantityProduce = 0;
      for (let i = 0; i < oldReceiptBillDetails.length; i++) {
        const element = oldReceiptBillDetails[i];
        quantityProduce += element.quantity;
      }
      item.totalWarehouse = quantityProduce;
      return quantityProduce;
    },
    sendQuotation(item) {
      alert(item);
      return;
      // this.$refs.bmanufacture.block();
      // manufactureService
      //   .sendEmail(item.id)
      //   .then(res => {
      //     this.$alertify.success(res.message, {
      //       duration: 4000
      //     });
      //   })
      //   .finally(() => {
      //     this.$refs.bmanufacture.unBlock();
      //   });
    },
    printOrder(item) {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(item, item.manufactureFeatures, item.manufactureParameters);
    }
  }
};
</script>
<style lang="scss">
// .soft-table {
//   .b-table-sticky-header {
//     max-height: 400px;
//   }
// }
.note-lct-index {
  overflow-y: auto;
  max-height: 90px;
  width: 450px;
  white-space: normal;
  p {
    margin: 0;
  }
}
</style>
